import React, { useState } from "react";
import NavItem from "./NavItem";
import { NavDataProps } from "../../types";
import { LinkOnlyWrapper } from "../../common/link/LinkOnly";
import { ChatBubbleLeftRightIcon } from "@heroicons/react/24/outline";

const Nav = ({ navData }: NavDataProps) => {
  const { navigation_menu, navigation_menu_button_link } = navData;
  const buttonLink = navigation_menu_button_link
    ?.value?.[0] as Queries.kontent_item_internal_link;
  const buttonLabel = buttonLink?.elements?.label?.value;
  const [activeId, setActiveId] = useState<string | null>(null);

  const handleActiveId = (id: string | null = null): void => {
    setActiveId(id === activeId ? null : id);
  };

  return (
    <>
      <div className="flex h-16 text-white bg-lime-500 relative z-90">
        <nav
          role="navigation"
          aria-label="Primary Navigation"
          className="ml-2 xl:ml-6 self-center"
        >
          <ul className="ml-8 lg:mr-10 xl:ml-4 xl:mr-2 flex items-center gap-x-4 xl:gap-6 2xl:gap-x-10">
            {navigation_menu?.value?.map((item: any) => (
              <NavItem
                key={item.id}
                item={item}
                activeId={activeId}
                handleActiveId={handleActiveId}
              />
            ))}
          </ul>
        </nav>

        <LinkOnlyWrapper
          linkData={buttonLink}
          className="inline-flex bg-slate-700 text-white text-lg font-bold px-10 items-center ml-auto hover:bg-black/50"
        >
          <ChatBubbleLeftRightIcon className="size-6 text-white mr-2 shrink-0" />
          <span className="whitespace-nowrap shrink-0">{buttonLabel}</span>
        </LinkOnlyWrapper>
      </div>
    </>
  );
};

export default Nav;
